import React from 'react';
import './main.css';
import { Typography } from "@material-ui/core";

import AppearingElement from "../Helper/AppearingElement";

function Video(props) {
    const videoRef = React.useRef();

    React.useEffect(() => {
        muteVideo();
    });

    const muteVideo = () => {
        const video = videoRef.current;
        video.volume = 0;
        video.muted = true;
    }

    return (
        <section className="video-section-app">
            <Typography variant="h3" className="video-section__header-app">
                <AppearingElement variant="zoom-down">
                    {props.header}
                </AppearingElement>
            </Typography>
            <video src={props.video} className="video-section__video-app" onClick={muteVideo} onPlay={muteVideo} onPause={muteVideo} ref={videoRef} controls playsInline muted preload="auto" />
        </section>
    )
}

export default Video